export function mapperInvalidFieldNameToMessage(requiredFieldName: string): string {
  const map = {
    'List Date': 'List date is not equal/older than Today'
  };
  return map[requiredFieldName]?.length ? map[requiredFieldName] : requiredFieldName;
}
